import { deleteBiometricCredentials } from "global/services/biometric/biometricService";

export const logoutApp = (history) => async (dispatch) => {
  history.push("/");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refreshToken");
  sessionStorage.removeItem("auth");

  localStorage.removeItem("publicidad_portal");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("token");

  // Borrar credenciales biométricas al cerrar sesión
  // try {
  //   await deleteBiometricCredentials();
  // } catch (error) {
  //   // Silenciar error si no hay credenciales para borrar
  //   console.log("No biometric credentials to delete");
  // }
};
